import { PATH_CHANGED } from '../actionTypes';

const initialState = {
  currentPath: null,
};

export function navReducer(state = initialState, action) {
  if (action.type === PATH_CHANGED) {
    return {
      ...state,
      currentPath: action.path,
    };
  }

  return state;
}
